import React, { useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import * as api from "../common/manipurCommon/API";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const ManipurLogin = () => {
  const route = all_routes;
  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [fgtUsrEmail, setFgtUsrEmail] = useState("");
  const [openModal, setOpenModal] = useState(false)

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  function login() {
    const formData = new FormData();
    formData.append('username', userName);
    formData.append('password', password);

    // formData.forEach((value, key) => {
    //   console.log(`${key}: ${value}`);
    // });
    const login = api.ManipurLogin;
    fetch(login, {
      method: "POST",
      body: formData
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.error == true) {
          // setError("User Credentials not valid. Please try again!");
          setError(result.message);
          // Swal.fire({ html: Object.values(result.message).join("<br/>") })
        }
        else {
          setError("");
          const loggedIn = result.data;
          const now = Date.now().toString();

          localStorage.setItem("UserName", loggedIn.userName);
          localStorage.setItem("FullName", loggedIn.firstNameLastName);
          localStorage.setItem("RoleId", loggedIn.userRole);
          localStorage.setItem("accessToken", loggedIn.token);
          localStorage.setItem("tokenIssuedAt", now);
          localStorage.setItem("lastActivityAt", now);
          localStorage.setItem('accessConfigValue', "1800");
          localStorage.setItem('refreshConfigValue', "1800");
          localStorage.setItem('closeConfigValue', "1800");

          navigate(route.dashboard);
        }
      })
  }

  function requestLink() {
    if (!fgtUsrEmail) {
      Swal.fire('Please fill the mandatory fields')
    } else {
      const formData = new FormData();
      formData.append('emailId', fgtUsrEmail)
      const getLink = api.ForgotPasswordLink;
      fetch(getLink, {
        method: "POST",
        body: formData
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.error == false) {
            Swal.fire({
              title: 'Success',
              text: result.message,
              icon: 'success',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((res) => {
              if (res.isConfirmed) {
                window.location.reload(); // 🔁 Reload only after OK is clicked
              }
            });
          } else {
            Swal.fire({
              title: 'Error',
              text: result.message.emailId,
              icon: 'error',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then((res) => {
              if (res.isConfirmed) {
                window.location.reload(); // 🔁 Reload only after OK is clicked
              }
            });
          }
        })
      setOpenModal(false)
    }
  }

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper authendication-pages">
        {/* Page Content */}
        <div className="content blur-ellipses login-password">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-7 mx-auto vph-100 d-flex align-items-center">
                <div className="change-password w-100">
                  <header className="text-center" style={{ paddingTop: "40px" }}>
                    <Link to={route.userDashboardProfiles}>
                      <ImageWithBasePath
                        // src="assets/img/logo-black.svg"
                        src="assets/img/tenvic/TENVICLogo.png"
                        className="img-fluid"
                        alt="Logo"
                        width={202}
                      />
                    </Link>
                  </header>
                  <div className="shadow-card">
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="user"
                        role="tabpanel"
                        aria-labelledby="user-tab"
                      >
                        {/* Login Form */}
                        <form onSubmit={(e) => { e.preventDefault(); login(); }}>
                          <div className="form-group">
                            <div className="group-img">
                              <i className="feather-user" />
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Email / Username"
                                value={userName}
                                onChange={(e) =>
                                  setUserName(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="pass-group group-img">
                              <i
                                className={`toggle-password ${passwordVisible ? "feather-eye" : "feather-eye-off"}`}
                                onClick={togglePasswordVisibility}
                              />
                              <input
                                type={passwordVisible ? "text" : "password"}
                                className="form-control pass-input"
                                placeholder="Password"
                                value={password}
                                onChange={(e) =>
                                  setPassword(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          {error && <div className="alert alert-danger">{error}</div>}
                          <div className="form-group d-sm-flex align-items-center justify-content-between">
                            <div className="form-check form-switch d-flex align-items-center justify-content-start">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="user-pass"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="user-pass"
                              >
                                Remember Password
                              </label>
                            </div>
                            <span>
                              <Link
                                to="#"
                                className="forgot-pass"
                                onClick={() => setOpenModal(true)}
                              >
                                Forgot Password
                              </Link>
                            </span>
                          </div>
                          <div className="text-center">
                            <button
                              type="submit"
                              className="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            >
                              Sign In
                              <i className="feather-arrow-right-circle ms-2" />
                            </button>
                          </div>
                        </form>
                        {/* /Login Form */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}

      {/* Forgot Password Modal */}
      <Modal
        show={openModal}
        size="md"
        centered
        onHide={() => setOpenModal(false)}
      >
        <ModalHeader>
          <ModalTitle><h4 className="text-center"><i className="fas fa-key" />Forgot Password</h4></ModalTitle>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </ModalHeader>
        <ModalBody>
          <div className="col-lg-12 mb-10">
            <label className="form-label">E Mail
            </label>
            <input
              type="email"
              className="form-control"
              style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
              id="stksze"
              value={fgtUsrEmail}
              onChange={(e) => { setFgtUsrEmail(e.target.value); }}
              placeholder="E Mail"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-primary text-uppercase"
            variant="success"
            onClick={requestLink}
            data-bs-dismiss="modal" aria-label="Close"
          >
            <b><i className="fas fa-save" /> Request</b>
          </Button>
        </ModalFooter>
      </Modal>

      {/* /Forgot Password Modal */}
    </>
  );
};

export default ManipurLogin;
